import React from "react";
import { Collapse } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import "./FAQ.css";

const { Panel } = Collapse;

const faqData = [
  {
    key: "1",
    question: "What services do you provide?",
    answer:
      "We provide custom enterprise Software Development, Web Development, Mobile App Development, AI Solutions, Cloud & DevOps, Digital Marketing, API Integration, and highly immersive IT Training programs."
  },
  {
    key: "2",
    question: "How long does a project take?",
    answer:
      "Project timelines depend entirely on the complexity of your requirements. Small projects typically take 1–2 weeks max, while custom enterprise-grade solutions with complex architectures can take several months of iterative development."
  },
  {
    key: "3",
    question: "What is the duration of your Internship & Training Program?",
    answer:
      "Our Internship & Training Program is designed for students and aspiring professionals with a flexible duration of 2 to 6 months. The program includes practical training, real-world projects, technical guidance, and industry-oriented learning based on the selected duration."
  },

  {
    key: "4",
    question: "Do you offer maintenance and support?",
    answer:
      "Yes, we do. We provide dedicated post-launch support and ongoing maintenance SLA packages, including performance optimization, critical bug fixes, library upgrades, security patches, and minor feature additions."
  },
  {
    key: "5",
    question: "Which technologies do you use?",
    answer:
      "We build our products using cutting-edge and modern technology stacks like React, Next.js, Node.js, Express, MongoDB, PostgreSQL, Flutter, React Native, Python, AWS, Docker, Kubernetes, and popular OpenAI framework integrations."
  },
  {
    key: "6",
    question: "How can I get a quotation?",
    answer:
      "Simply reach out to us using our website's contact form, book a consultation call, or email us your detailed requirements document. Our team of analysts will evaluate your scope and deliver a comprehensive commercial proposal within 24 hours."
  }
];

export default function FAQ() {
  return (
    <section className="faq-light-sec">
      {/* Premium Atmospheric Light Background Overlays */}
      <div className="faq-bg-grid-light"></div>
      <div className="faq-radial-glow-light-1"></div>
      <div className="faq-radial-glow-light-2"></div>

      <div className="faq-container-light">
        {/* Header Block */}
        <div className="faq-header-block-light">
          <span className="faq-badge-light">
            <span className="faq-badge-dot-light"></span>
            QUESTIONS & ANSWERS
          </span>
          <h2>
            Frequently Asked <span className="highlight-orange-light">Questions</span>
          </h2>
          <p>
            Everything you need to know about our digital services, execution timelines, and development process. Can't find the answers you need? Get in touch with our engineering team.
          </p>
        </div>

        {/* Ant Design Collapse with robust light-theme overrides */}
        <Collapse
          accordion
          ghost
          expandIcon={({ isActive }) =>
            isActive ? (
              <span className="faq-icon-box-light active">
                <MinusOutlined />
              </span>
            ) : (
              <span className="faq-icon-box-light">
                <PlusOutlined />
              </span>
            )
          }
        >
          {faqData.map((item) => (
            <Panel
              header={item.question}
              key={item.key}
              className="faq-panel-custom-light"
            >
              <div className="faq-answer-container-light">
                <p>{item.answer}</p>
              </div>
            </Panel>
          ))}
        </Collapse>
      </div>
    </section>
  );
}